import { ButtonType } from 'reducers/rating/PhotoRatingState'

export const SET_ACTIVE_KEYBOARD_BUTTON = 'SET_ACTIVE_KEYBOARD_BUTTON' as const

export const setActiveKeyboardButtonAction = (button: ButtonType) => ({
  type: SET_ACTIVE_KEYBOARD_BUTTON,
  button,
})

export type SetActiveKeyboardButton = ReturnType<
  typeof setActiveKeyboardButtonAction
>
